import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Who,
  Why,
  Benefits,
  Values,
  Distribution,
  NetworkPlaybook,
  Metrics,
  Pricing,
  AreYouReady,
} from './components';
import {
  mediaLabWho,
  mediaLabWhy,
  mediaLabBenefits,
  mediaLabValues,
  mediaLabDistribution,
  mediaLabPlaybook,
  mediaLabMetrics,
  mediaLabAreYouReady,
} from './mediaLabContent';
import { CherryDevTheme } from '../CherrySoftware/CherryDevTheme';
import { CHERRY_DEV } from '../CherrySoftware/cherryDevBrand';
import { CHERRY_SOFTWARE_CONTAINER_PROPS } from '../CherrySoftware/cherrySoftwareLayout';

const LandingMediaKitCreatorInner = ({ themeMode = 'light' }) => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  });

  useEffect(() => {
    document.title = 'TNO Media Lab | Laboratorio de contenidos';
  }, []);

  return (
    <Box
      sx={{
        bgcolor: CHERRY_DEV.cream,
        fontFamily: '"Outfit", "Segoe UI", system-ui, sans-serif',
      }}
    >
      <Box bgcolor={CHERRY_DEV.blush}>
        <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS} paddingY={{ xs: 3, sm: 4, md: 6 }}>
          <Who themeMode={themeMode} content={mediaLabWho} forceContent />
        </Container>
      </Box>
      <Container
        sx={{
          position: 'relative',
          backgroundImage: 'url("/images/tno-team-tnonetwork.jpg")',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          minHeight: '60vh',
        }}
        borderRadius={isSm ? 4 : 0}
      >
        <Box
          sx={{
            position: 'absolute',
            left: { xs: 16, md: 28 },
            bottom: { xs: 16, md: 28 },
          }}
        >
          <Box
            component="img"
            src="/images/logos/iso_white.webp"
            alt="TNO Network"
            sx={{ height: { xs: 36, md: 46 }, width: 'auto', display: 'block' }}
          />
        </Box>
      </Container>
      <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
        <Why content={mediaLabWhy} />
      </Container>
      <Box bgcolor={CHERRY_DEV.blush}>
        <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
          <Benefits themeMode={themeMode} content={mediaLabBenefits} />
        </Container>
      </Box>
      <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
        <Values content={mediaLabValues} />
      </Container>
      <Box bgcolor={CHERRY_DEV.blush}>
        <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
          <Distribution content={mediaLabDistribution} />
        </Container>
      </Box>
      <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
        <NetworkPlaybook content={mediaLabPlaybook} />
      </Container>
      <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
        <Metrics metrics={mediaLabMetrics} />
      </Container>
      <Box bgcolor={CHERRY_DEV.blush}>
        <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
          <Pricing pricingOptions={[]} />
        </Container>
      </Box>
      <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
        <AreYouReady content={mediaLabAreYouReady} />
      </Container>
    </Box>
  );
};

const LandingMediaKitCreator = ({ themeMode = 'light' }) => (
  <CherryDevTheme>
    <LandingMediaKitCreatorInner themeMode={themeMode} />
  </CherryDevTheme>
);

LandingMediaKitCreator.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default LandingMediaKitCreator;
